import React, { FunctionComponent } from 'react';
import { Button, Stack } from '@mui/material';

import { DistanceField } from '@paragon/material';

import { deleteFixedWebJoint, shiftWebJointPosition } from '../../../../../../store/actions/profileActions';
import { selectItem } from '../../../../../../store/actions/selectActions';
import { getSingleSelectedItemEntryOrNull } from '../../../../../../store/selectors/getSelectedItemSelector';
import { getComponentDesignBeingInserted } from '../../../../../../store/selectors/insertionObjectSelectors';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';

const WebJointEditor: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const componentDesign = useAppSelector(getComponentDesignBeingInserted);
  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);
  const isRewebbing = useAppSelector((state) => !!state.application.rewebbingInfo);

  if (selectedEntry?.type !== 'webJoint' || (!isRewebbing && !componentDesign)) return null;

  const updateWebJoint = async (x: number) =>
    await dispatch(shiftWebJointPosition(selectedEntry.item.guid, x - selectedEntry.item.x));

  const deleteSelectedWebJoint = () => {
    if (componentDesign) dispatch(selectItem(componentDesign, 'componentDesign'));
    dispatch(deleteFixedWebJoint(selectedEntry.item));
  };

  return (
    <Stack direction="row" spacing={1}>
      <DistanceField
        sx={{ flexBasis: '50%' }}
        label="Horizontal Distance"
        value={selectedEntry.item.x}
        onSubmit={(x) => updateWebJoint(x)}
      />

      <Button size="small" variant="outlined" sx={{ flexBasis: '50%' }} onClick={deleteSelectedWebJoint}>
        Remove joint
      </Button>
    </Stack>
  );
};

export default WebJointEditor;
